import { Observable } from 'rxjs';
import { BaseController } from '~client/controller/base-controller';
import { ChangePasswordRequest } from '~client/model/change-password-request';
import { ClientProfileResponse } from '~client/model/client-profile-response';
import { CreateAccountRequest } from '~client/model/create-account-request';
import { EmptyResponseEntity } from '~client/model/empty-response-entity';
import { InitiateResetPasswordRequest } from '~client/model/initiate-reset-password-request';
import { IsEmailAddressAvailableRequest } from '~client/model/is-email-address-available-request';
import { LoginRequest } from '~client/model/login-request';
import { ResponseEntity } from '~client/model/response-entity';
import { UserLoginResponse } from '~client/model/user-login-response';
import { VerifyEmailRequest } from '~client/model/verify-email-request';
import { VerifyResetPasswordEmailRequest } from '~client/model/verify-reset-password-email-request';
import { VerifyResetPasswordEmailResponse } from '~client/model/verify-reset-password-email-response';

/* User APIs to login/logout, create account, verify email addresses and reset password */
export class UserLoginController extends BaseController {
  /* Allows the user to create their account */
  public createAccount$(request: CreateAccountRequest): Observable<UserLoginResponse> {
    return this.post$('/auth/createAccount', request);
  }

  /* Allows the user to login */
  public login$(request: LoginRequest): Observable<UserLoginResponse> {
    return this.post$('/auth/login', request);
  }

  /* Allows the user to logout and delete their device token */
  public logout$(): Observable<null> {
    return this.post$('/auth/logout');
  }

  /* Allows the user to change their password after they have entered the verification code */
  public changePassword$(request: ChangePasswordRequest): Observable<UserLoginResponse> {
    return this.put$('/auth/changePassword', request);
  }

  /* Allows the user to verify their email address */
  public verifyEmail$(request: VerifyEmailRequest): Observable<ClientProfileResponse> {
    return this.get$('/auth/verifyAccountEmail', request);
  }

  /* Allows the user to verify the reset password email */
  public verifyResetPasswordEmail$(
    request: VerifyResetPasswordEmailRequest,
  ): Observable<VerifyResetPasswordEmailResponse> {
    return this.get$('/auth/verifyResetPasswordEmail', request);
  }

  /* Allows the user to resend the email verification code, this will send an email to the user */
  public resendVerificationLink$(): Observable<EmptyResponseEntity> {
    return this.put$('/auth/resendVerificationLink');
  }

  /* Allows the user to initiate a password reset. */
  public initiateResetPassword$(request: InitiateResetPasswordRequest): Observable<ResponseEntity> {
    return this.put$('/auth/initiateResetPassword', request);
  }

  /* Checks if an email used for creating an account is still available */
  public isEmailAddressAvailable$(
    request: IsEmailAddressAvailableRequest,
  ): Observable<ResponseEntity> {
    return this.get$('/auth/isEmailAddressAvailable', request);
  }

  /* Allows the user to delete their account. */
  public deleteAccount(): Promise<ResponseEntity> {
    return this.del('/auth/deleteAccount');
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src891534606/src/modules/client/src/controller/user-login-controller.ts